import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { auth as authApi } from '@/api/auth';
import { useAuth } from '@/auth/AuthContext';
import Spinner from '@/components/Spinner';

type State = 'pending' | 'success' | 'error';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { refresh } = useAuth();
  const [state, setState] = useState<State>('pending');

  useEffect(() => {
    if (!token) {
      setState('error');
      return;
    }
    (async () => {
      try {
        await authApi.verifyEmail(token);
        await refresh();
        setState('success');
      } catch {
        setState('error');
      }
    })();
  }, [token, refresh]);

  return (
    <div className="centered-full login-card">
      <div className="login-inner">
        <h1>Email verification</h1>
        {state === 'pending' && <Spinner />}
        {state === 'success' && (
          <>
            <p>Your email is verified. You can now invite teammates.</p>
            <Link to="/dashboard" className="btn btn-primary">
              Go to dashboard
            </Link>
          </>
        )}
        {state === 'error' && (
          <>
            <p className="muted">
              The verification link is invalid or has expired. Sign in and request a new one from
              the banner at the top of the dashboard.
            </p>
            <Link to="/login" className="btn btn-ghost">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
